export default __webpack_public_path__ + "images/RJ.5a21fc1.png";